export const MinutesPerMove = [
  { title: '1/3', value: 20 },
  { title: '1/2', value: 30 },
  { title: '1', value: 60 },
  { title: '2', value: 120 },
];
